import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=281e59ec&scoped=true"
import script from "./Donation.vue?vue&type=script&lang=js"
export * from "./Donation.vue?vue&type=script&lang=js"
import style0 from "./Donation.vue?vue&type=style&index=0&id=281e59ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e59ec",
  null
  
)

export default component.exports